import styled from "styled-components";

const S = {
    Wrapper: styled.header`
        position: ${props => props.isHome ? "fixed" : "sticky"};
        background-color: ${props => props.fontColor ? "rgba(0,0,0,0.15)" : "rgba(255, 255, 255, 0.96)"};
        backdrop-filter: blur(12px);
        transition: background-color 0.3s ease, box-shadow 0.3s ease, border-radius 0.3s ease;
        box-shadow: ${props => !props.fontColor ? "0 4px 20px rgba(0, 0, 0, 0.08)" : "none"}; 
        top: 0;
        left: 0;
        right: 0;
        display: flex;
        align-items: center;
        justify-content: space-between;
        padding: 8px 32px;
        z-index: 1000;
        box-sizing: border-box;
        border-radius: ${props => props.fontColor ? "0px" : "0 0 16px 16px"};

        @media (max-width: 1024px) {
            padding: 8px 16px;
            background-color: ${props => props.fontColor ? (props.menuOpen ? "rgba(255, 255, 255, 0.98)" : "rgba(0,0,0,0.2)") : "rgba(255, 255, 255, 0.98)"};
        }
    `,

    Logo: styled.a`
        display: flex;
        align-items: center;
        width: 180px;
        z-index: 200;
        padding: 6px 0;
        cursor: pointer;
        transition: opacity 0.2s ease, transform 0.2s ease;

        &:hover {
            opacity: 0.9;
        }

        img {
            width: 100%;
            height: auto;
            max-height: 48px;
            object-fit: contain;
        }

        @media (max-width: 1024px) {
            width: 135px;
            img {
                max-height: 40px;
            }
        }
    `,

    DesktopNav: styled.ul`
        margin: 0;
        padding: 0;
        display: flex;
        align-items: center;
        list-style: none;
        gap: 16px;

        @media (max-width: 1024px) {
            display: none;
        }

        li {
            position: relative;
            list-style: none;
            font-size: 14px;
            font-weight: 700;

            > a {
                text-decoration: none;
                color: ${props => props.fontColor ? "#ffffff" : "#222222"};
                padding: 8px 6px;
                border-radius: 6px;
                display: inline-flex;
                align-items: center;
                transition: color 0.25s ease, background-color 0.25s ease;

                &:hover {
                    color: #00A9C4;
                }
            }
        }

        .dropdown {
            position: relative;
            cursor: pointer;
            color: ${props => props.fontColor ? "#ffffff" : "#222222"};
            padding: 8px 6px;
            display: inline-flex;
            align-items: center;
            gap: 4px;
            transition: color 0.25s ease;

            &:hover {
                color: #00A9C4;
                .dropdown-menu {
                    opacity: 1;
                    visibility: visible;
                    transform: translateY(0);
                    pointer-events: auto;
                }
            }
        }

        .dropdown-menu {
            opacity: 0;
            visibility: hidden;
            transform: translateY(8px);
            transition: opacity 0.2s ease, transform 0.2s ease, visibility 0.2s ease;
            position: absolute;
            top: 100%;
            left: 0;
            min-width: 250px;
            background: #ffffff;
            box-shadow: 0 10px 30px rgba(0, 0, 0, 0.12);
            border-radius: 12px;
            padding: 8px 0;
            margin-top: 4px;
            z-index: 1001;
            pointer-events: none;
            border: 1px solid rgba(0, 0, 0, 0.06);

            a {
                display: block;
                padding: 9px 18px;
                font-size: 13px;
                font-weight: 600;
                color: #333333;
                text-decoration: none;
                transition: background-color 0.2s ease, color 0.2s ease, padding-left 0.2s ease;

                &:hover {
                    background-color: #f0faff;
                    color: #01aecb;
                    padding-left: 22px;
                }
            }
        }
    `,

    RightSection: styled.div`
        display: flex;
        align-items: center;
        gap: 12px;
    `,

    LangWrapper: styled.div`
        display: flex;
        align-items: center;
    `,

    HamburgerButton: styled.button`
        display: none;
        background: ${props => props.isOpen ? "#01aecb" : (props.fontColor ? "rgba(255, 255, 255, 0.2)" : "#f1f5f9")};
        color: ${props => props.isOpen ? "#ffffff" : (props.fontColor ? "#ffffff" : "#1e293b")};
        border: none;
        border-radius: 10px;
        width: 42px;
        height: 42px;
        align-items: center;
        justify-content: center;
        cursor: pointer;
        transition: all 0.25s ease;
        padding: 0;
        outline: none;

        &:hover {
            background: ${props => props.isOpen ? "#0196af" : "#e2e8f0"};
        }

        svg {
            font-size: 24px;
        }

        @media (max-width: 1024px) {
            display: flex;
        }
    `,

    DrawerOverlay: styled.div`
        position: fixed;
        inset: 0;
        background: rgba(15, 23, 42, 0.6);
        backdrop-filter: blur(4px);
        z-index: 1998;
        opacity: ${props => props.isOpen ? 1 : 0};
        visibility: ${props => props.isOpen ? "visible" : "hidden"};
        transition: opacity 0.3s cubic-bezier(0.4, 0, 0.2, 1), visibility 0.3s cubic-bezier(0.4, 0, 0.2, 1);
    `,

    Drawer: styled.div`
        position: fixed;
        top: 0;
        right: 0;
        bottom: 0;
        width: 86%;
        max-width: 360px;
        height: 100vh;
        height: 100dvh;
        background: #ffffff;
        z-index: 1999;
        box-shadow: -8px 0 30px rgba(0, 0, 0, 0.15);
        transform: ${props => props.isOpen ? "translateX(0)" : "translateX(100%)"};
        transition: transform 0.35s cubic-bezier(0.4, 0, 0.2, 1);
        display: flex;
        flex-direction: column;
        box-sizing: border-box;
    `,

    DrawerHeader: styled.div`
        display: flex;
        align-items: center;
        justify-content: space-between;
        padding: 16px 20px;
        border-bottom: 1px solid #f1f5f9;
        background: #ffffff;

        .drawer-logo {
            width: 130px;
            img {
                width: 100%;
                height: auto;
                max-height: 38px;
            }
        }

        .close-btn {
            background: #f1f5f9;
            border: none;
            width: 36px;
            height: 36px;
            border-radius: 50%;
            display: flex;
            align-items: center;
            justify-content: center;
            cursor: pointer;
            color: #475569;
            transition: all 0.2s ease;

            &:hover {
                background: #e2e8f0;
                color: #0f172a;
            }

            svg {
                font-size: 20px;
            }
        }
    `,

    DrawerBody: styled.div`
        flex: 1;
        overflow-y: auto;
        padding: 12px 16px 30px;
        display: flex;
        flex-direction: column;
        gap: 6px;
        -webkit-overflow-scrolling: touch;

        &::-webkit-scrollbar {
            width: 4px;
        }
        &::-webkit-scrollbar-thumb {
            background: #cbd5e1;
            border-radius: 4px;
        }
    `,

    DrawerItem: styled.div`
        > a {
            display: flex;
            align-items: center;
            padding: 12px 14px;
            font-size: 15px;
            font-weight: 700;
            color: #1e293b;
            text-decoration: none;
            border-radius: 10px;
            transition: all 0.2s ease;

            &:hover, &:active {
                background-color: #f0faff;
                color: #01aecb;
            }
        }
    `,

    DrawerAccordion: styled.div`
        display: flex;
        flex-direction: column;
    `,

    DrawerAccordionButton: styled.button`
        display: flex;
        align-items: center;
        justify-content: space-between;
        width: 100%;
        padding: 12px 14px;
        font-size: 15px;
        font-weight: 700;
        color: ${props => props.isOpen ? "#01aecb" : "#1e293b"};
        background: ${props => props.isOpen ? "#f0faff" : "transparent"};
        border: none;
        border-radius: 10px;
        cursor: pointer;
        text-align: left;
        transition: all 0.2s ease;

        &:hover {
            background-color: #f0faff;
            color: #01aecb;
        }

        .chevron {
            font-size: 20px;
            transition: transform 0.25s ease;
            transform: ${props => props.isOpen ? "rotate(180deg)" : "rotate(0)"};
            color: ${props => props.isOpen ? "#01aecb" : "#94a3b8"};
        }
    `,

    DrawerSubmenu: styled.div`
        display: ${props => props.isOpen ? "flex" : "none"};
        flex-direction: column;
        padding: 4px 0 6px 12px;
        margin-left: 10px;
        border-left: 2px solid #e0f2fe;
        gap: 2px;
        animation: fadeIn 0.25s ease;

        @keyframes fadeIn {
            from {
                opacity: 0;
                transform: translateY(-6px);
            }
            to {
                opacity: 1;
                transform: translateY(0);
            }
        }

        a {
            display: block;
            padding: 9px 12px;
            font-size: 13.5px;
            font-weight: 600;
            color: #475569;
            text-decoration: none;
            border-radius: 8px;
            transition: all 0.2s ease;

            &:hover, &:active {
                background-color: #f0faff;
                color: #01aecb;
                padding-left: 16px;
            }
        }
    `
};

export default S;